require('./scss/app.scss');
const $ = require('jquery');
const Foundation = require('foundation-sites');
window.$ = window.jQuery = $;

if (!Number.parseFloat) { Number.parseFloat = parseFloat; }
if (!Number.isNaN) { Number.isNaN = isNaN; }

var full = 0, percent = 0, partner = 0;
var dFull = 0, dPercent = 0, dPartner = 0;

function calculateSaving() {
	full = 0;
	$('.l-benefit input[data-benefit="1"]').prop('checked') ? full = full + 20 : false;
	$('.l-benefit input[data-benefit="2"]').prop('checked') ? full = full + 90 : false;
	$('.l-benefit input[data-benefit="3a"]').prop('checked') ? full = full + 280 : false;
	$('.l-benefit input[data-benefit="3b"]').prop('checked') ? full = full + 350 : false;
	$('.l-benefit input[data-benefit="4"]').prop('checked') ? full = full + 160 : false;
	$('.l-benefit input[data-benefit="5"]').prop('checked') ? full = full + 300 : false;
	$('.l-benefit input[data-benefit="6"]').prop('checked') ? full = full + 29 : false;
	$('.l-benefit input[data-benefit="7"]').prop('checked') ? full = full + 173 : false;
	$('.l-benefit input[data-benefit="50"]').prop('checked') ? full = full + 150 : false;
	$('.l-benefit input[data-benefit="8"]').prop('checked') ? full = full + 270 : false;
	// $('.l-benefit input[data-benefit="9"]').prop('checked') ? full = full + 140 : false;
	// $('.l-benefit input[data-benefit="10"]').prop('checked') ? full = full + 165 : false;
	$('.l-benefit input[data-benefit="11"]').prop('checked') ? full = full + 510 : false;
	$('.l-benefit input[data-benefit="12"]').prop('checked') ? full = full + 215 : false;
	$('.l-benefit input[data-benefit="13"]').prop('checked') ? full = full + 200 : false;
	$('.l-benefit input[data-benefit="14"]').prop('checked') ? full = full + 80 : false;
	$('.l-benefit input[data-benefit="15"]').prop('checked') ? full = full + 250 : false;
	$('.l-benefit input[data-benefit="16"]').prop('checked') ? full = full + 390 : false;
	$('.l-benefit input[data-benefit="17"]').prop('checked') ? full = full + 150 : false;
	$('.l-benefit input[data-benefit="18"]').prop('checked') ? full = full + 300 : false;
	$('.l-benefit input[data-benefit="19"]').prop('checked') ? full = full + 55 : false;

	var brutto = 0, avgsav = 0;
	var bruttoString = $('.l-calc-input-brutto input').val().replace(".", "").replace(",", ".");
	brutto = Math.min(Number.parseFloat(bruttoString), 58050);
	var avgsavString = $('.l-calc-input-avgsaving input').val().replace(",", ".");
	avgsav = (Number.parseFloat(avgsavString) - 16.1) / 2;
	percent = brutto * avgsav / 100;

	partner = percent + full;
	$('.l-calc-full').text(full.toFixed(0) + ' €');
	if (Number.isNaN(full)) { $('.l-calc-full').text('ungültige Eingabe'); }
	$('.l-calc-percent').text(percent.toFixed(0) + ' €');
	if (Number.isNaN(percent)) { $('.l-calc-percent').text('ungültige Eingabe'); }
	$('.l-calc-bkk-partner').text(partner.toFixed(0) + ' €');
	if (Number.isNaN(partner)) { $('.l-calc-bkk-partner').text('ungültige Eingabe'); }
}

function refresh() {
	if (full == dFull && percent == dPercent && partner == dPartner) { return; }
	requestAnimationFrame(refresh);

}

$(document.body).on('change', '.l-benefit .l-checkbox-wrap input[type="checkbox"]', calculateSaving);
$('.l-calc-input-brutto input').on('input', calculateSaving);
$('.l-calc-input-avgsaving input').on('input', calculateSaving);


// WEBPACK FOOTER //
// ./src/app.js